export default import.meta.ROLLDOWN_FILE_URL_0$5w4vF2CxwJn5AYBhKPyw